import type { TErrorPayload } from '@cascade/api-client/events';
import { RequestError } from '@cascade/core/errors';
import { isMessageUnfinished } from '#providers/conversations/Conversations.helpers.ts';
import type { TMessage } from '#providers/conversations/Conversations.types.ts';

export const createRequestId = (): string =>
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

export const toErrorPayload = (error: unknown): TErrorPayload => {
  if (!(error instanceof RequestError)) {
    return { message: error instanceof Error ? error.message : String(error) };
  }

  const { detail } = error;

  return {
    code: detail.kind,
    reason: 'reason' in detail ? detail.reason : undefined,
    message: error.message,
    ...(detail.kind === 'server' ? detail.body : undefined),
  };
};

export const hasPendingAnswer = (messages: TMessage[]): boolean => {
  const last = messages.at(-1);

  return last ? isMessageUnfinished(last) : false;
};
